import './AudioPlayer.scss';

//TODO: To be continued ....
//TODO: duration error
//TODO: circular progress bar like: https://codepen.io/yondmn/pen/wOYYvd
//TODO: Volume progressbar

import React, {useState, useRef, useEffect} from 'react';
import snippets from "../../../helpers/snippets";

function AudioPlayer({src}) {
    const audioRef = useRef(null);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const [isPlaying, setIsPlaying] = useState(false);

    const [volume, setVolume] = useState(40);
    const [muted, setMuted] = useState(false);

    useEffect(()=>{
        if (audioRef.current){
            setDuration(audioRef.current.duration)
        }
        return (()=>{
            setIsPlaying(false)
        })
    }, [audioRef, src])

    useEffect(() => {
        if (audioRef) {
            if (volume <= 5){
                audioRef.current.volume = 0;
                audioRef.current.muted = true
            } else {
                audioRef.current.volume = volume / 100;
                audioRef.current.muted = muted;
            }
        }
    }, [volume, audioRef, muted]);


    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (isPlaying) {
            audio.pause();
            setIsPlaying(false);
        } else {
            audio.play();
            setIsPlaying(true);
        }
    };

    const handleProgress = () => {
        const audio = audioRef.current;
        const progress = audio.currentTime / audio.duration;
        setCurrentTime(audio.currentTime);
        setDuration(audioRef.current.duration);
    };

    const handleSeek = (event) => {
        const audio = audioRef.current;
        const seekTime = event.target.value * audio.duration;
        audio.currentTime = seekTime;
        setCurrentTime(audio.currentTime);
    };
    // const progressStyle = {
    //     width: `${(currentTime / duration) * 100}%`,
    // };



    return (
        <div className={"AudioPlayer"}>
            <audio
                ref={audioRef}
                src={src}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onTimeUpdate={handleProgress}
                onLoadedMetadata={handleProgress}
                // onCanPlay={handleProgress}
            />
            <div className={"AudioPlayer__button section__record__circle"}
                onClick={handlePlayPause}
            >
                {isPlaying ?
                    <i className={'fal fa-pause'}/>
                    :
                    <i className={'fal fa-play'}/>
                }
            </div>
            <div className={"AudioPlayer__progressBar"} >
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    // ref={progressBarRef}
                    value={currentTime / duration || 0}
                    onChange={handleSeek}
                    // style={{ display: "none" }}
                />


            </div>
            <div className={"duration"}>
                {snippets.minTwoDigits((currentTime).toFixed(2))}
            </div>
            <div className={"volume"}>
                <div className={"section__record__circle"} onClick={() => setVolume((prev) => ((prev + 20) % 100))}>
                    {muted || volume < 5 ? (
                        <i className={'fal fa-volume-mute'}/>
                    ) : volume < 40 ? (
                        <i className={'fal fa-volume-down'}/>
                    ) : volume < 70 ? (
                        <i className={'fal fa-volume-medium'}/>
                    ) : (
                        <i className={'fal fa-volume-high'}/>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AudioPlayer;